export default "__VITE_ASSET__BzZ3Vr2u__"